module.exports = __webpack_public_path__ + "img/train-stop-shadow.b6dec367.png";